import React, { lazy } from 'react';

import { useTranslation } from '~/app';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '~/components/Dialog/Dialog';

/**
 * @author      Michael Hettmer <mail@michael-hettmer.de>
 * @copyright   2019 Plusbyte UG (haftungsbeschränkt)
 * @license     {@link https://plusbyte.de Plusbyte License}
 */

interface RegisterProps {
  email: string;
  password: string;
  firebaseIdToken?: string;
  modalOpen: boolean;
  onRegistrationSuccess: () => void;
  onRegistrationCancelled: () => void;
  onBackToLogin: () => void;
}

const RegisterFirebaseLazy = lazy(() => import('./RegisterFirebase'));

const Register = ({
  email,
  password,
  firebaseIdToken,
  modalOpen,
  onRegistrationSuccess,
  onRegistrationCancelled,
  onBackToLogin,
}: RegisterProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Dialog open={modalOpen} onOpenChange={(open) => !open && onRegistrationCancelled()}>
      <DialogContent size="2xl" className="max-w-5xl">
        <DialogTitle>{t('start_accountRegisterDialogTitle')}</DialogTitle>
        <DialogDescription>{t('start_accountRegisterDialogContent')}</DialogDescription>

        <div className="@container mt-4">
          {typeof window !== 'undefined' && (
            <React.Suspense fallback={<div />}>
              <RegisterFirebaseLazy
                email={email}
                password={password}
                firebaseIdToken={firebaseIdToken}
                onFirebaseRegistrationSuccess={onRegistrationSuccess}
                onBackToLogin={onBackToLogin}
              />
            </React.Suspense>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default Register;
